<template>
  <div style="margin: 0 40px 12px;">
    <div style="display: flex; align-items: center">
      <div>金额：</div>
      <el-input v-model="money" placeholder="请输入金额" style="width: 100%; flex: 1"/>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateMeituanStat} from "@/api/url";
import {moneyReg} from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      priceForm: this.value.priceForm,
      type: this.value.type,
      money:this.value.type == 1?this.value.priceForm.meituanMoney:this.value.priceForm.tiktokMoney
    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.money) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入价格',
          type: 'warning'
        });
        return false
      }else if(!moneyReg.test(this.money)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确金额',
          type: 'warning'
        });
        return false
      }
      let param = {}
      param['id'] = this.priceForm.id
      param['type'] = this.type
      param['money'] = this.money
      postFormData(updateMeituanStat, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
